import { render } from "./baskets-panel.vue?vue&type=template&id=c5b7c4f6"
import script from "./baskets-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./baskets-panel.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./baskets-panel.vue?vue&type=style&index=0&id=c5b7c4f6&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./baskets-panel.vue?vue&type=style&index=0&id=c5b7c4f6&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("c5b7c4f6")
  })
}

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/vueComponents/admin/analytics/components/baskets-panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5b7c4f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5b7c4f6', __exports__)) {
    api.reload('c5b7c4f6', __exports__)
  }
  
  module.hot.accept("./baskets-panel.vue?vue&type=template&id=c5b7c4f6", () => {
    api.rerender('c5b7c4f6', render)
  })

}


export default __exports__